import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@mui/material';

export const NotificationsCard = ({useJobConfig}) => {
  const [emailRecipients, setEmailRecipients] = useJobConfig(["emailConfig", "emailContacts"]);
  const [successEmails, setSuccessEmails] = useJobConfig(["emailConfig", "sendSuccessEmails"]);
  const [emailJobName, setEmailJobName] = useJobConfig(["emailConfig", "emailJobName"]);
  return <Card>
    <CardHeader title="Notifications" subheader="Who gets notified when this feed runs." />
    <CardContent>
      <FormGroup>
        <TextField
          fullWidth
          id="email_recipients"
          label="Email recipients"
          variant="standard"
          placeholder='benefits@acme.com, payroll@acme.com'
          helperText="Comma separated, leave blank for no notifications."
          value={(emailRecipients || []).join(", ")}
          onChange={e => setEmailRecipients(e.target.value.split(/[, ]+/))}
        />
        <TextField
          fullWidth
          id="email_job_name"
          label="Email job name"
          variant="standard"
          placeholder="Cresco Export"
          helperText="Optional name used in the email. Leave blank to use the partner and job type."
          value={emailJobName || ""}
          onChange={e => setEmailJobName(e.target.value.trim() === "" ? undefined : e.target.value)}
        />
        <FormControlLabel
          control={<Checkbox />}
          label={<>
            Send notifications on successful runs (in adition to failures)
          </>}
          checked={successEmails === "true"}
          onChange={(e, checked) => setSuccessEmails(checked ? "true" : "false")}
        />
      </FormGroup>
    </CardContent>
  </Card>
}
